import { createFileRoute, Navigate } from '@tanstack/react-router';

/** Legacy hub segment; Billing merged into Transactions and Billing. */
const Component = () => {
  const { familyId } = Route.useParams();
  return (
    <Navigate
      to='/families/$familyId/transactions'
      params={{ familyId }}
      replace
    />
  );
};

export const Route = createFileRoute(
  '/_auth/_layout/families/$familyId/billing',
)({
  component: Component,
});
